import type { OrganizationStatus } from '@sentinel/shared';
import type { StateTone } from '@sentinel/ui';

/** The tone of an organization's state: open, on trial, read-only, closed. */
export const ORGANIZATION_TONE: Record<OrganizationStatus, StateTone> = {
  active: 'ok',
  trial: 'info',
  suspended: 'att',
  archived: 'off',
};

/** «12 / 50», «12 / —» without a limit (a dash, never a zero that is not there). */
export function usageOf(used: number, limit: number | null): string {
  return `${String(used)} / ${limit === null ? '—' : String(limit)}`;
}
